const params = new URLSearchParams(location.search);
const ref = params.get('ref');
if (ref) {
  try { localStorage.setItem('tm_ref', ref); } catch (e) {}
}
const guardado = (() => { try { return localStorage.getItem('tm_ref'); } catch (e) { return null; } })();
if (guardado) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { ref: guardado } }),
  }).catch(() => {});
}
